import Product from './Product';

export default function ChildProduct() {
  return Product.named('ChildProduct');
}
